import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'
import { Default, Mobile, isNarrowDesktop, isTablet } from '../../media-queries'
import InfoBlock from '../shared/infoBlock'
import Step from './step'
import AngleBracketButton from '../shared/angleBracketButton'
import AngleBracket from '../shared/angleBracket'
import Checked from '../shared/checked'
import Unchecked from '../shared/unchecked'
import Cross from '../shared/cross'

export default class ApplicationRequirements extends Component {
  constructor(props) {
    super(props)
    const requirementsCount = props.requirements.length
    this.state = {
      requirementsCount,
      confirmedRequirements: {},
      activeRequirement: '',
    }
  }

  render() {
    return (
      <div>
        <Default>
          <DefaultApplicationRequirements
            {...this.props}
            {...this.state}
            toggleConfirm={this.toggleConfirm}
            setActiveRequirement={this.setActiveRequirement}
            getButtonProps={this.buttonProps}
          />
        </Default>
        <Mobile>
          {this.state.activeRequirement == null ||
          this.state.activeRequirement.length === 0 ? (
            <MobileApplicationRequirements
              {...this.props}
              {...this.state}
              toggleConfirm={this.toggleConfirm}
              setActiveRequirement={this.setActiveRequirement}
            />
          ) : (
            <MobileInfo
              {...this.props}
              {...this.state}
              toggleConfirm={this.toggleConfirm}
              setActiveRequirement={this.setActiveRequirement}
              height={this.getHeight()}
            />
          )}
        </Mobile>
      </div>
    )
  }

  getHeight = () => {
    if (typeof window !== 'undefined') {
      return window.innerHeight - 56
    }
  }

  toggleConfirm = (e, req) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (this.state.confirmedRequirements.hasOwnProperty(req)) {
      this.setState(prevState => {
        delete prevState.confirmedRequirements[req]
        return { confirmedRequirements: prevState.confirmedRequirements }
      })
    } else {
      this.setState(prevState => ({
        confirmedRequirements: { ...prevState.confirmedRequirements, [req]: 1 },
      }))
    }
  }

  setActiveRequirement = req => this.setState({ activeRequirement: req })

  buttonProps = target => ({
    style: {
      border:
        Object.keys(this.state.confirmedRequirements).indexOf(target) !== -1 &&
        '3px solid white',
      background:
        Object.keys(this.state.confirmedRequirements).indexOf(target) !== -1
          ? 'none'
          : 'white',
    },
    textStyle: {
      color:
        Object.keys(this.state.confirmedRequirements).indexOf(target) !== -1
          ? 'white'
          : 'black',
    },
    hasCaret:
      Object.keys(this.state.confirmedRequirements).indexOf(target) === -1,
    hasShadow:
      Object.keys(this.state.confirmedRequirements).indexOf(target) === -1,
  })
}

const MobileInfo = props => (
  <div
    style={{
      background: '#8CBD8C',
      padding: '1rem 2rem',
      minHeight: props.height,
    }}
  >
    <div
      style={{
        background: 'white',
        minHeight: props.height - 32,
        paddingTop: '1rem',
        overflowY: 'scroll',
        display: 'grid',
      }}
    >
      <div style={{ width: 18, margin: '0 1rem 0 auto' }}>
        <Cross color={'black'} onClick={() => props.setActiveRequirement('')} />
      </div>
      <div
        style={{
          padding: '1rem 2rem',
        }}
      >
        {props.requirements.map(req => {
          if (req.title === props.activeRequirement) {
            return (
              <InfoBlock
                title={req.title}
                extra={req.titleAccent}
                accentColor={'#8CBD8C'}
                text={req.text.internal.content}
                key={req.title}
              />
            )
          }
        })}
        <div style={{ marginTop: '2rem' }}>
          <span
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignContent: 'center',
              margin: '0 auto 0 0',
            }}
          >
            {typeof props.confirmedRequirements[props.activeRequirement] !==
            'undefined' ? (
              <Checked
                onClick={e => props.toggleConfirm(e, props.activeRequirement)}
              />
            ) : (
              <Unchecked
                onClick={e => props.toggleConfirm(e, props.activeRequirement)}
              />
            )}
            <span
              onClick={e => props.toggleConfirm(e, props.activeRequirement)}
              className={'unselectable'}
            >
              &nbsp;Confirm
            </span>
          </span>
        </div>
      </div>
      <div
        style={{ margin: 'auto auto 1rem 2rem', fontSize: 13 }}
        onClick={() => props.setActiveRequirement('')}
      >
        Close
      </div>
    </div>
  </div>
)

const MobileApplicationRequirements = props => (
  <div
    style={{
      background: '#8CBD8C',
    }}
  >
    <InfoBlock
      title={props.header.title}
      bigTitle={true}
      extra={props.header.titleAccent}
      accentColor={'white'}
      text={props.header.text.internal.content}
      style={{ padding: '1rem 2rem' }}
    />
    <div style={{ margin: '0 3rem', paddingBottom: '1rem' }}>
      <Step {...props.step} />
    </div>
    <div style={{ padding: '1rem 2rem' }}>
      {props.requirements.map(({ title }) => (
        <div
          style={{
            background: 'white',
            padding: '1rem 1.5rem',
            fontSize: 16,
            fontWeight: 600,
            marginBottom: '1rem',
            display: 'flex',
            justifyContent: 'space-between',
          }}
          key={title}
        >
          <span
            onClick={() => {
              if (window) window.scrollTo(0, 0)
              props.setActiveRequirement(title)
            }}
          >
            {title}
          </span>
          <span style={{ marginLeft: 5 }}>
            {typeof props.confirmedRequirements[title] !== 'undefined' ? (
              <Checked onClick={e => props.toggleConfirm(e, title)} />
            ) : (
              <Unchecked onClick={e => props.toggleConfirm(e, title)} />
            )}
          </span>
        </div>
      ))}
    </div>
    <div
      style={{
        margin: '0 2rem 2rem',
        border: `3px solid white`,
        padding: '1.5em',
        textAlign: 'center',
        color:
          Object.keys(props.confirmedRequirements).length ===
          props.requirements.length
            ? 'black'
            : 'white',
        fontSize: 18,
        fontWeight: 600,
        background:
          Object.keys(props.confirmedRequirements).length ===
          props.requirements.length
            ? 'white'
            : '#8CBD8C',
        cursor:
          Object.keys(props.confirmedRequirements).length ===
          props.requirements.length
            ? 'pointer'
            : '',
      }}
      className={`unselectable ${
        Object.keys(props.confirmedRequirements).length ===
        props.requirements.length
          ? 'card'
          : ''
      }`}
      onClick={() => {
        if (
          Object.keys(props.confirmedRequirements).length ===
          props.requirements.length
        )
          props.nextStep()
      }}
    >
      Continue
    </div>
    <div
      style={{
        margin: '1rem 3rem',
        fontStyle: 'italic',
        fontSize: 12,
      }}
    >
      {props.closingText}
    </div>
    <div
      style={{
        padding: '2rem 2rem 3rem',
        fontSize: 14,
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <div onClick={props.previousStep} style={{ cursor: 'pointer' }}>
        <AngleBracket
          color={'black'}
          style={{
            width: 5,
            transform: 'scaleX(-1)',
            filter: 'FlipH',
          }}
        />
        <span>&nbsp;&nbsp;Back</span>
      </div>
    </div>
  </div>
)

const DefaultApplicationRequirements = props => (
  <div
    style={{
      display: 'flex',
    }}
  >
    <div
      style={{
        background: 'white',
        minHeight: props.height,
        padding: isTablet()
          ? '2rem 4rem 3rem'
          : `2rem ${isNarrowDesktop() ? '5rem' : '7rem'} 2rem 5rem`,
        width: '58vw',
      }}
    >
      <InfoBlock
        title={props.header.title}
        bigTitle={true}
        extra={props.header.titleAccent}
        accentColor={'#8CBD8C'}
        text={props.header.text.internal.content}
      />
      <div
        style={{
          position: 'relative',
        }}
      >
        {props.requirements.map(({ title, text }) => (
          <div
            key={title}
            style={{
              position: 'absolute',
            }}
          >
            <Fade when={props.activeRequirement === title} collapse>
              <InfoBlock
                title={title}
                childrenBetween={true}
                text={text.internal.content}
              >
                <div style={{ marginTop: '1rem' }}>
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {typeof props.confirmedRequirements[title] !==
                    'undefined' ? (
                      <Checked
                        style={{
                          cursor: 'pointer',
                        }}
                        onClick={e => props.toggleConfirm(e, title)}
                      />
                    ) : (
                      <Unchecked
                        style={{
                          cursor: 'pointer',
                        }}
                        onClick={e => props.toggleConfirm(e, title)}
                      />
                    )}
                    <span
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={e => props.toggleConfirm(e, title)}
                      className={'unselectable'}
                    >
                      &nbsp;Confirm
                    </span>
                  </span>
                </div>
              </InfoBlock>
            </Fade>
          </div>
        ))}
      </div>
    </div>
    <div
      style={{
        background: '#8CBD8C',
        minHeight: props.height,
        padding: `15vh ${isNarrowDesktop() ? '8vw' : '12.5vw'} 1rem ${
          isNarrowDesktop() ? '1rem' : '3rem'
        }`,
        width: '42vw',
      }}
    >
      <div style={{ marginBottom: '3rem' }}>
        <Step {...props.step} />
      </div>
      {props.requirements.map(({ title }, i) => (
        <AngleBracketButton
          caretPosition={'left'}
          caretDirection={'left'}
          text={title}
          key={title}
          {...props.getButtonProps(title)}
          style={{
            marginBottom:
              i === props.requirements.length
                ? Object.keys(props.confirmedRequirements).indexOf(title) !== -1
                  ? -6
                  : 0
                : i === 0
                  ? 0
                  : Object.keys(props.confirmedRequirements).indexOf(title) !==
                    -1
                    ? ' calc(.5rem - 3px)'
                    : '.5rem',
            marginTop:
              i === props.requirements.length
                ? 0
                : i === 0
                  ? Object.keys(props.confirmedRequirements).indexOf(title) !==
                    -1
                    ? -6
                    : 0
                  : Object.keys(props.confirmedRequirements).indexOf(title) !==
                    -1
                    ? ' calc(.5rem - 3px)'
                    : '.5rem',
            ...props.getButtonProps(title).style,
          }}
          onClick={() => props.setActiveRequirement(title)}
        />
      ))}
      <div
        style={{
          marginTop: '3rem',
          border: '3px solid white',
          padding: '1.5em',
          textAlign: 'center',
          color:
            Object.keys(props.confirmedRequirements).length ===
            props.requirementsCount
              ? 'black'
              : 'white',
          fontSize: 18,
          fontWeight: 600,
          background:
            Object.keys(props.confirmedRequirements).length ===
            props.requirementsCount
              ? 'white'
              : 'none',
          cursor:
            Object.keys(props.confirmedRequirements).length ===
            props.requirementsCount
              ? 'pointer'
              : '',
        }}
        className={`unselectable ${
          Object.keys(props.confirmedRequirements).length ===
          props.requirementsCount
            ? 'card'
            : ''
        }`}
        onClick={() => {
          if (
            Object.keys(props.confirmedRequirements).length ===
            props.requirementsCount
          )
            props.nextStep()
        }}
      >
        Continue
      </div>
      <div
        style={{
          margin: '2rem 0 3rem',
          fontStyle: 'italic',
          fontSize: 12,
        }}
      >
        {props.closingText}
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <div onClick={props.previousStep} style={{ cursor: 'pointer' }}>
          <AngleBracket
            color={'black'}
            style={{
              width: 5,
              transform: 'scaleX(-1)',
              filter: 'FlipH',
            }}
          />
          <span>&nbsp;&nbsp;Back</span>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/application/applicationRequirements.js